import ChevronRight from "@mui/icons-material/ChevronRight";
import { SvgIconProps } from "@mui/material/SvgIcon";
import clsx from "clsx";
import React, { FunctionComponent } from "react";
import { flipRTL } from "designSystem/styles/css";

interface ChevronRightIconProps extends SvgIconProps {
}

const ChevronRightIcon: FunctionComponent<ChevronRightIconProps> = (props) => {
	const { className, ...otherProps } = props;
	return (
		<ChevronRight
			className={clsx(className, flipRTL)}
			{...otherProps}
		/>
	);
};

export default ChevronRightIcon;

